module.exports = __webpack_public_path__ + "img/shop.e9818ecc.png";